export enum Flow {
  PROFILE = 'Profile',
  PURCHASE_FLOW = 'Purchase flow',
}
